import AccessRequest from "@/views/accessRequest/AccessRequest.vue";
import type { RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  organization: "AccessRequest.Organization",
  facility: "AccessRequest.Facility",
};

export { names as accessRequestRouteNames };

const accessRequestRoutes: RouterOptions["routes"] = [
  {
    path: "/organization-access-request",
    name: names.organization,
    meta: { title: "Organization Access Request New", isNew: true },
    component: {
      render: () => <AccessRequest entityLabel="Organization" entityName="Organization" />,
    },
  },
  {
    path: "/facility-access-request",
    name: names.facility,
    meta: { title: "Facility Access Request New", isNew: true },
    component: {
      render: () => <AccessRequest entityLabel="Facility" entityName="Facility" />,
    },
  },
];
export default accessRequestRoutes;
